import _ from "lodash";
import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";

export class EnsenyamentsPreinscripcioData {
  ensenyamentsPreinscripcio: any[] = [];
  naturalesas: any[] = [];
  nivell: any[] = [];
  private ariFilter: any[] = [];

  constructor() { }

  getAriFilter(): any[] {
    return this.ariFilter;
  }

  setAriFilter(newVal: any[]): void {
    this.ariFilter = newVal;
  }

  reset() {
    this.resetRec(this.ensenyamentsPreinscripcio);
    this.resetRec(this.naturalesas);
    this.resetRec(this.nivell);
  };

  resetRec(_ensenyamentsPreinscripcio) {
    _ensenyamentsPreinscripcio.forEach((element) => {
      element.value = false;
      if (element.subnodes != null) {
        this.resetRec(element.subnodes);
      }
    });
  };

  getEnsenyamentsFromAriFilter(): any[] {
    return _.map(this.ariFilter, 'tipus');
  }

  getNivellsFromAriFilter(): any[] {
    return _.flatten(_.map(this.ariFilter, 'nivells'));
  }

  getElementsSQLFilter(_ensenyamentsPreinscripcio) {
    var arrEnsenyamentsPreinscripcio = {};
    var filter = "";
    _ensenyamentsPreinscripcio.forEach((elemet, i) => {
      var id = elemet.id;
      if (!arrEnsenyamentsPreinscripcio.hasOwnProperty(id)) {
        arrEnsenyamentsPreinscripcio[id] = id;
        if (+i != 0) {
          filter += ", ";
        }
        filter += "'" + id + "' ";
      }
    });
    return filter;
  };
}

angularJsApp.service(AppServicesEnum.ENSENYAMENTS_PREINSCRIPCIO_DATA_SERVICE, EnsenyamentsPreinscripcioData);